var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"font-weight-bold text-uppercase"},[_vm._v("Planos de Profissionais")]),_c('hr',{staticClass:"linha-amarela"}),_c('form',_vm._l((_vm.professionalPlans),function(plan,index){return _c('ProfessionalPlanCard',{key:index,attrs:{"pPlanData":plan}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }